import { AxiosError } from 'axios';
import { Observable, throwError } from 'rxjs';
import { AppError } from '../models/app-error';

export class BaseService {

  protected doCache: boolean;
  constructor() {
    this.doCache = false;
  }

  protected pagedUrl(url: string, currentpage?: number, pagesize?: number): string {
    if (url === null && currentpage != null && pagesize != null) {
      url = `?currentpage=${currentpage}&pagesize=${pagesize}`;
    }
    else if (url === null && currentpage != null) {
      url = `?currentpage=${currentpage}`;
    }
    else if (url === null && pagesize != null) {
      url = `?pagesize=${pagesize}`;
    }
    else if (url != null) {
      // our searches have these
      if (url.indexOf('?') > -1) {
        url += `&currentpage=${currentpage}&pagesize=${pagesize}`;
      }
      else {
        url += `?currentpage=${currentpage}&pagesize=${pagesize}`;
      }
    }
    return url;
  }

  protected handleHttpError(error: AxiosError): Observable<AppError> {
    return throwError(this.createHtppError(error));
  }
  
  protected createHtppError(error: AxiosError): AppError {
    const dataError = new AppError();
    dataError.errorNumber = error.status;
    dataError.message = error.message;
    dataError.friendlyMessage = 'An error occurred retrieving data.';
    return dataError;
  }
}
